import { EmailTemplateSection } from './types';

// Common template wrapper parts
const TEMPLATE_HEAD = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
  <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <meta http-equiv="X-UA-Compatible" content="IE=edge" />
  <meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
  <meta name="x-apple-disable-message-reformatting" />
  <title>EAS Email Template Example</title>
  <!--[if mso]>
  <noscript>
    <xml>
      <o:OfficeDocumentSettings>
        <o:PixelsPerInch>96</o:PixelsPerInch>
      </o:OfficeDocumentSettings>
    </xml>
  </noscript>
  <![endif]-->
</head>
<body style="margin: 0 !important; padding: 0 !important; width: 100% !important; background-color: #dfdfdf; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%;">
  <!--[if mso]>
  <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%" bgcolor="#dfdfdf">
  <tr><td align="center">
  <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="660">
  <tr><td>
  <![endif]-->
  
  <!-- Main wrapper table -->
  <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #dfdfdf; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
    <tr>
      <td align="center" valign="top">
        <!-- Email container -->
        <table border="0" cellpadding="0" cellspacing="0" width="660" style="max-width: 660px; background-color: #ffffff; mso-table-lspace: 0pt; mso-table-rspace: 0pt;" role="presentation">`;

const TEMPLATE_FOOTER = `        </table>
        <!-- End Email container -->
      </td>
    </tr>
  </table>
  <!-- End Main wrapper table -->
  
  <!--[if mso]>
  </td></tr></table>
  </td></tr></table>
  <![endif]-->
</body>
</html>`;

// Section: Headings
const SECTION_HEADINGS = `          <!-- ============================================
               SECTION 1: HEADINGS DEMONSTRATION
          ============================================ -->
          <tr>
            <td style="background-color: #ffffff; padding: 24px;">
              <h1 style="margin: 0 0 20px 0; color: #00629b; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 32px; font-weight: bold; line-height: 1.2;">Heading Level 1 (H1)</h1>
              <p style="margin: 0 0 16px 0; color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">This is the main page heading. Used once for the primary email title.</p>
              
              <h2 style="margin: 0 0 16px 0; color: #00629b; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 26px; font-weight: bold; line-height: 1.3;">Heading Level 2 (H2)</h2>
              <p style="margin: 0 0 16px 0; color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">Second level heading. Used for main sections of the email.</p>
              
              <h3 style="margin: 0 0 14px 0; color: #00629b; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 22px; font-weight: bold; line-height: 1.3;">Heading Level 3 (H3)</h3>
              <p style="margin: 0 0 16px 0; color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">Third level heading. Subsections within main sections.</p>
              
              <h4 style="margin: 0 0 12px 0; color: #00629b; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 18px; font-weight: bold; line-height: 1.4;">Heading Level 4 (H4)</h4>
              <p style="margin: 0 0 16px 0; color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">Fourth level heading. For more detailed structuring.</p>
              
              <h5 style="margin: 0 0 10px 0; color: #00629b; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 16px; font-weight: bold; line-height: 1.4;">Heading Level 5 (H5)</h5>
              <p style="margin: 0 0 16px 0; color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">Fifth level heading. Small subheadings.</p>
              
              <h6 style="margin: 0 0 8px 0; color: #00629b; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; font-weight: bold; line-height: 1.4;">Heading Level 6 (H6)</h6>
              <p style="margin: 0; color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">Sixth level heading. The smallest heading.</p>
            </td>
          </tr>`;

// Section: Paragraphs
const SECTION_PARAGRAPHS = `          <!-- ============================================
               SECTION 2: PARAGRAPHS
          ============================================ -->
          <tr>
            <td style="background-color: #f5f5f5; padding: 24px;">
              <h2 style="margin: 0 0 16px 0; color: #00629b; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 26px; font-weight: bold; line-height: 1.3; text-align: center;">Paragraph Examples</h2>
              
              <p style="margin: 0 0 16px 0; color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">This is the first paragraph of text. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.</p>
              
              <p style="margin: 0 0 16px 0; color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">This is the second paragraph with <strong>bold text</strong> and <em>italics</em>. You can also use <a href="#" style="color: #f05f26; text-decoration: underline;">inline links</a> for navigation.</p>
              
              <p style="margin: 0; color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">This is the third paragraph without bottom margin. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
            </td>
          </tr>`;

// Section: Unordered Lists
const SECTION_UNORDERED_LISTS = `          <!-- ============================================
               SECTION 3: UNORDERED LISTS
          ============================================ -->
          <tr>
            <td style="background-color: #ffffff; padding: 24px;">
              <h2 style="margin: 0 0 16px 0; color: #00629b; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 26px; font-weight: bold; line-height: 1.3;">Unordered Lists</h2>
              
              <h4 style="margin: 0 0 12px 0; color: #00629b; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 18px; font-weight: bold; line-height: 1.4;">Standard list (disc):</h4>
              <table border="0" cellpadding="0" cellspacing="0" width="100%" role="presentation" style="margin: 0 0 16px 0; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                <tr>
                  <td width="24" valign="top" style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">&bull;</td>
                  <td style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6; padding-bottom: 8px;">First list item</td>
                </tr>
                <tr>
                  <td width="24" valign="top" style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">&bull;</td>
                  <td style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6; padding-bottom: 8px;">Second list item</td>
                </tr>
                <tr>
                  <td width="24" valign="top" style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">&bull;</td>
                  <td style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6; padding-bottom: 8px;">Third list item with longer text that may wrap to the next line</td>
                </tr>
                <tr>
                  <td width="24" valign="top" style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">&bull;</td>
                  <td style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">Fourth list item</td>
                </tr>
              </table>
              
              <h4 style="margin: 0 0 12px 0; color: #00629b; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 18px; font-weight: bold; line-height: 1.4;">Circle list:</h4>
              <table border="0" cellpadding="0" cellspacing="0" width="100%" role="presentation" style="margin: 0 0 16px 0; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                <tr>
                  <td width="24" valign="top" style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">&#9675;</td>
                  <td style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6; padding-bottom: 8px;">Item with empty circle</td>
                </tr>
                <tr>
                  <td width="24" valign="top" style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">&#9675;</td>
                  <td style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6; padding-bottom: 8px;">Another item</td>
                </tr>
                <tr>
                  <td width="24" valign="top" style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">&#9675;</td>
                  <td style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">And one more</td>
                </tr>
              </table>
              
              <h4 style="margin: 0 0 12px 0; color: #00629b; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 18px; font-weight: bold; line-height: 1.4;">Square list:</h4>
              <table border="0" cellpadding="0" cellspacing="0" width="100%" role="presentation" style="margin: 0 0 16px 0; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                <tr>
                  <td width="24" valign="top" style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">&#9632;</td>
                  <td style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6; padding-bottom: 8px;">Item with square</td>
                </tr>
                <tr>
                  <td width="24" valign="top" style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">&#9632;</td>
                  <td style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6; padding-bottom: 8px;">Second item</td>
                </tr>
                <tr>
                  <td width="24" valign="top" style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">&#9632;</td>
                  <td style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">Third item</td>
                </tr>
              </table>
            </td>
          </tr>`;

// Section: Ordered Lists
const SECTION_ORDERED_LISTS = `          <!-- ============================================
               SECTION 4: ORDERED LISTS
          ============================================ -->
          <tr>
            <td style="background-color: #f5f5f5; padding: 24px;">
              <h2 style="margin: 0 0 16px 0; color: #00629b; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 26px; font-weight: bold; line-height: 1.3;">Ordered Lists</h2>
              
              <h4 style="margin: 0 0 12px 0; color: #00629b; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 18px; font-weight: bold; line-height: 1.4;">Standard numbered list:</h4>
              <table border="0" cellpadding="0" cellspacing="0" width="100%" role="presentation" style="margin: 0 0 16px 0; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                <tr>
                  <td width="24" valign="top" style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">1.</td>
                  <td style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6; padding-bottom: 8px;">Register on the EAS platform</td>
                </tr>
                <tr>
                  <td width="24" valign="top" style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">2.</td>
                  <td style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6; padding-bottom: 8px;">Connect your e-commerce platform</td>
                </tr>
                <tr>
                  <td width="24" valign="top" style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">3.</td>
                  <td style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6; padding-bottom: 8px;">Configure VAT settings</td>
                </tr>
                <tr>
                  <td width="24" valign="top" style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">4.</td>
                  <td style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">Start automatic reporting</td>
                </tr>
              </table>
              
              <h4 style="margin: 0 0 12px 0; color: #00629b; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 18px; font-weight: bold; line-height: 1.4;">Alphabetic list (a, b, c):</h4>
              <table border="0" cellpadding="0" cellspacing="0" width="100%" role="presentation" style="margin: 0 0 16px 0; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                <tr>
                  <td width="24" valign="top" style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">a.</td>
                  <td style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6; padding-bottom: 8px;">First step</td>
                </tr>
                <tr>
                  <td width="24" valign="top" style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">b.</td>
                  <td style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6; padding-bottom: 8px;">Second step</td>
                </tr>
                <tr>
                  <td width="24" valign="top" style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">c.</td>
                  <td style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6; padding-bottom: 8px;">Third step</td>
                </tr>
                <tr>
                  <td width="24" valign="top" style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">d.</td>
                  <td style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">Fourth step</td>
                </tr>
              </table>
              
              <h4 style="margin: 0 0 12px 0; color: #00629b; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 18px; font-weight: bold; line-height: 1.4;">Roman numerals list:</h4>
              <table border="0" cellpadding="0" cellspacing="0" width="100%" role="presentation" style="margin: 0 0 16px 0; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                <tr>
                  <td width="24" valign="top" style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">i.</td>
                  <td style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6; padding-bottom: 8px;">Introduction</td>
                </tr>
                <tr>
                  <td width="24" valign="top" style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">ii.</td>
                  <td style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6; padding-bottom: 8px;">Main content</td>
                </tr>
                <tr>
                  <td width="24" valign="top" style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">iii.</td>
                  <td style="color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6;">Conclusion</td>
                </tr>
              </table>
            </td>
          </tr>`;

// Section: Buttons
const SECTION_BUTTONS = `          <!-- ============================================
               SECTION 5: BUTTONS
          ============================================ -->
          <tr>
            <td style="background-color: #ffffff; padding: 24px;">
              <h2 style="margin: 0 0 16px 0; color: #00629b; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 26px; font-weight: bold; line-height: 1.3; text-align: center;">Buttons</h2>
              
              <h4 style="margin: 0 0 12px 0; color: #00629b; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 18px; font-weight: bold; line-height: 1.4;">Main buttons:</h4>
              <table border="0" cellpadding="0" cellspacing="0" width="100%" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                <tr>
                  <td align="center" style="padding: 12px 0;">
                    <!-- Primary Button - Bulletproof -->
                    <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                      <tr>
                        <td align="center" bgcolor="#f05f26" style="border-radius: 8px;">
                          <!--[if mso]>
                          <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="#" style="height:48px;v-text-anchor:middle;width:200px;" arcsize="17%" stroke="f" fillcolor="#f05f26">
                          <w:anchorlock/>
                          <center style="color:#ffffff;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:16px;font-weight:bold;">Primary Button</center>
                          </v:roundrect>
                          <![endif]-->
                          <!--[if !mso]><!-->
                          <a href="#" style="display: inline-block; padding: 14px 28px; font-family: 'Helvetica Neue', Helvetica, Arial, Verdana, sans-serif; font-size: 16px; font-weight: bold; text-decoration: none; text-align: center; border-radius: 8px; background-color: #f05f26; color: #ffffff;">Primary Button</a>
                          <!--<![endif]-->
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td align="center" style="padding: 12px 0;">
                    <!-- Secondary Button - Bulletproof -->
                    <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                      <tr>
                        <td align="center" bgcolor="#00629b" style="border-radius: 8px;">
                          <!--[if mso]>
                          <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="#" style="height:48px;v-text-anchor:middle;width:200px;" arcsize="17%" stroke="f" fillcolor="#00629b">
                          <w:anchorlock/>
                          <center style="color:#ffffff;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:16px;font-weight:bold;">Secondary Button</center>
                          </v:roundrect>
                          <![endif]-->
                          <!--[if !mso]><!-->
                          <a href="#" style="display: inline-block; padding: 14px 28px; font-family: 'Helvetica Neue', Helvetica, Arial, Verdana, sans-serif; font-size: 16px; font-weight: bold; text-decoration: none; text-align: center; border-radius: 8px; background-color: #00629b; color: #ffffff;">Secondary Button</a>
                          <!--<![endif]-->
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td align="center" style="padding: 12px 0;">
                    <!-- Outline Button - Bulletproof -->
                    <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                      <tr>
                        <td align="center" style="border-radius: 8px; border: 2px solid #f05f26;">
                          <!--[if mso]>
                          <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="#" style="height:48px;v-text-anchor:middle;width:200px;" arcsize="17%" stroke="t" strokecolor="#f05f26" strokeweight="2px" fillcolor="#ffffff">
                          <w:anchorlock/>
                          <center style="color:#f05f26;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:16px;font-weight:bold;">Outline Button</center>
                          </v:roundrect>
                          <![endif]-->
                          <!--[if !mso]><!-->
                          <a href="#" style="display: inline-block; padding: 14px 28px; font-family: 'Helvetica Neue', Helvetica, Arial, Verdana, sans-serif; font-size: 16px; font-weight: bold; text-decoration: none; text-align: center; border-radius: 8px; background-color: #ffffff; color: #f05f26;">Outline Button</a>
                          <!--<![endif]-->
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
              
              <h4 style="margin: 24px 0 12px 0; color: #00629b; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 18px; font-weight: bold; line-height: 1.4;">Button sizes:</h4>
              <table border="0" cellpadding="0" cellspacing="0" width="100%" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                <tr>
                  <td align="center" style="padding: 12px 0;">
                    <!-- Small Button -->
                    <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                      <tr>
                        <td align="center" bgcolor="#f05f26" style="border-radius: 8px;">
                          <!--[if mso]>
                          <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="#" style="height:38px;v-text-anchor:middle;width:150px;" arcsize="21%" stroke="f" fillcolor="#f05f26">
                          <w:anchorlock/>
                          <center style="color:#ffffff;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:14px;font-weight:bold;">Small Button</center>
                          </v:roundrect>
                          <![endif]-->
                          <!--[if !mso]><!-->
                          <a href="#" style="display: inline-block; padding: 10px 20px; font-family: 'Helvetica Neue', Helvetica, Arial, Verdana, sans-serif; font-size: 14px; font-weight: bold; text-decoration: none; text-align: center; border-radius: 8px; background-color: #f05f26; color: #ffffff;">Small Button</a>
                          <!--<![endif]-->
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td align="center" style="padding: 12px 0;">
                    <!-- Normal Button -->
                    <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                      <tr>
                        <td align="center" bgcolor="#f05f26" style="border-radius: 8px;">
                          <!--[if mso]>
                          <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="#" style="height:48px;v-text-anchor:middle;width:200px;" arcsize="17%" stroke="f" fillcolor="#f05f26">
                          <w:anchorlock/>
                          <center style="color:#ffffff;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:16px;font-weight:bold;">Normal Button</center>
                          </v:roundrect>
                          <![endif]-->
                          <!--[if !mso]><!-->
                          <a href="#" style="display: inline-block; padding: 14px 28px; font-family: 'Helvetica Neue', Helvetica, Arial, Verdana, sans-serif; font-size: 16px; font-weight: bold; text-decoration: none; text-align: center; border-radius: 8px; background-color: #f05f26; color: #ffffff;">Normal Button</a>
                          <!--<![endif]-->
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td align="center" style="padding: 12px 0;">
                    <!-- Large Button -->
                    <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                      <tr>
                        <td align="center" bgcolor="#f05f26" style="border-radius: 8px;">
                          <!--[if mso]>
                          <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="#" style="height:58px;v-text-anchor:middle;width:250px;" arcsize="14%" stroke="f" fillcolor="#f05f26">
                          <w:anchorlock/>
                          <center style="color:#ffffff;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:18px;font-weight:bold;">Large Button</center>
                          </v:roundrect>
                          <![endif]-->
                          <!--[if !mso]><!-->
                          <a href="#" style="display: inline-block; padding: 18px 36px; font-family: 'Helvetica Neue', Helvetica, Arial, Verdana, sans-serif; font-size: 18px; font-weight: bold; text-decoration: none; text-align: center; border-radius: 8px; background-color: #f05f26; color: #ffffff;">Large Button</a>
                          <!--<![endif]-->
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
              
              <h4 style="margin: 24px 0 12px 0; color: #00629b; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 18px; font-weight: bold; line-height: 1.4;">Buttons in a row:</h4>
              <table border="0" cellpadding="0" cellspacing="0" width="100%" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                <tr>
                  <td align="center" width="50%" style="padding: 8px;">
                    <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                      <tr>
                        <td align="center" bgcolor="#f05f26" style="border-radius: 8px;">
                          <!--[if mso]>
                          <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="#" style="height:48px;v-text-anchor:middle;width:150px;" arcsize="17%" stroke="f" fillcolor="#f05f26">
                          <w:anchorlock/>
                          <center style="color:#ffffff;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:16px;font-weight:bold;">Confirm</center>
                          </v:roundrect>
                          <![endif]-->
                          <!--[if !mso]><!-->
                          <a href="#" style="display: inline-block; padding: 14px 28px; font-family: 'Helvetica Neue', Helvetica, Arial, Verdana, sans-serif; font-size: 16px; font-weight: bold; text-decoration: none; text-align: center; border-radius: 8px; background-color: #f05f26; color: #ffffff;">Confirm</a>
                          <!--<![endif]-->
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td align="center" width="50%" style="padding: 8px;">
                    <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                      <tr>
                        <td align="center" style="border-radius: 8px; border: 2px solid #f05f26;">
                          <!--[if mso]>
                          <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="#" style="height:48px;v-text-anchor:middle;width:150px;" arcsize="17%" stroke="t" strokecolor="#f05f26" strokeweight="2px" fillcolor="#ffffff">
                          <w:anchorlock/>
                          <center style="color:#f05f26;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:16px;font-weight:bold;">Cancel</center>
                          </v:roundrect>
                          <![endif]-->
                          <!--[if !mso]><!-->
                          <a href="#" style="display: inline-block; padding: 14px 28px; font-family: 'Helvetica Neue', Helvetica, Arial, Verdana, sans-serif; font-size: 16px; font-weight: bold; text-decoration: none; text-align: center; border-radius: 8px; background-color: #ffffff; color: #f05f26;">Cancel</a>
                          <!--<![endif]-->
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>`;

// Section: Data Table
const SECTION_DATA_TABLE = `          <!-- ============================================
               SECTION 6: DATA TABLE
          ============================================ -->
          <tr>
            <td style="background-color: #f5f5f5; padding: 24px;">
              <h2 style="margin: 0 0 16px 0; color: #00629b; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 26px; font-weight: bold; line-height: 1.3; text-align: center;">Data Tables</h2>
              
              <h4 style="margin: 0 0 12px 0; color: #00629b; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 18px; font-weight: bold; line-height: 1.4;">Service pricing table:</h4>
              <table border="0" cellpadding="0" cellspacing="0" width="100%" role="presentation" style="border-collapse: collapse; margin: 16px 0; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                <thead>
                  <tr>
                    <th style="background-color: #00629b; color: #ffffff; padding: 12px 16px; text-align: left; font-weight: bold; border: 1px solid #004d7a;">Service</th>
                    <th style="background-color: #00629b; color: #ffffff; padding: 12px 16px; text-align: left; font-weight: bold; border: 1px solid #004d7a;">Description</th>
                    <th style="background-color: #00629b; color: #ffffff; padding: 12px 16px; text-align: center; font-weight: bold; border: 1px solid #004d7a;">Period</th>
                    <th style="background-color: #00629b; color: #ffffff; padding: 12px 16px; text-align: right; font-weight: bold; border: 1px solid #004d7a;">Price</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style="padding: 12px 16px; border: 1px solid #e0e0e0; color: #474747; background-color: #ffffff;"><strong>IOSS Basic</strong></td>
                    <td style="padding: 12px 16px; border: 1px solid #e0e0e0; color: #474747; background-color: #ffffff;">Basic IOSS registration</td>
                    <td style="padding: 12px 16px; border: 1px solid #e0e0e0; color: #474747; text-align: center; background-color: #ffffff;">Month</td>
                    <td style="padding: 12px 16px; border: 1px solid #e0e0e0; color: #474747; text-align: right; background-color: #ffffff;">€29</td>
                  </tr>
                  <tr>
                    <td style="padding: 12px 16px; border: 1px solid #e0e0e0; color: #474747; background-color: #f9f9f9;"><strong>IOSS Pro</strong></td>
                    <td style="padding: 12px 16px; border: 1px solid #e0e0e0; color: #474747; background-color: #f9f9f9;">Extended plan with reporting</td>
                    <td style="padding: 12px 16px; border: 1px solid #e0e0e0; color: #474747; text-align: center; background-color: #f9f9f9;">Month</td>
                    <td style="padding: 12px 16px; border: 1px solid #e0e0e0; color: #474747; text-align: right; background-color: #f9f9f9;">€79</td>
                  </tr>
                  <tr>
                    <td style="padding: 12px 16px; border: 1px solid #e0e0e0; color: #474747; background-color: #ffffff;"><strong>UK VAT</strong></td>
                    <td style="padding: 12px 16px; border: 1px solid #e0e0e0; color: #474747; background-color: #ffffff;">UK VAT registration and reporting</td>
                    <td style="padding: 12px 16px; border: 1px solid #e0e0e0; color: #474747; text-align: center; background-color: #ffffff;">Month</td>
                    <td style="padding: 12px 16px; border: 1px solid #e0e0e0; color: #474747; text-align: right; background-color: #ffffff;">€99</td>
                  </tr>
                  <tr>
                    <td style="padding: 12px 16px; border: 1px solid #e0e0e0; color: #474747; background-color: #f9f9f9;"><strong>Full Compliance</strong></td>
                    <td style="padding: 12px 16px; border: 1px solid #e0e0e0; color: #474747; background-color: #f9f9f9;">Complete EU + UK package</td>
                    <td style="padding: 12px 16px; border: 1px solid #e0e0e0; color: #474747; text-align: center; background-color: #f9f9f9;">Month</td>
                    <td style="padding: 12px 16px; border: 1px solid #e0e0e0; color: #474747; text-align: right; background-color: #f9f9f9;">€149</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>`;

// Section: Call to Action
const SECTION_CTA = `          <!-- ============================================
               SECTION 7: CALL TO ACTION
          ============================================ -->
          <tr>
            <td style="background-color: #ffffff; padding: 24px;">
              <h2 style="margin: 0 0 16px 0; color: #00629b; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 26px; font-weight: bold; line-height: 1.3; text-align: center;">Ready to Get Started?</h2>
              <p style="margin: 0 0 16px 0; color: #474747; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 14px; line-height: 1.6; text-align: center;">Join thousands of companies already using EAS to automate their tax reporting.</p>
              <table border="0" cellpadding="0" cellspacing="0" width="100%" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                <tr>
                  <td align="center" style="padding: 16px 0;">
                    <!-- CTA Large Button -->
                    <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                      <tr>
                        <td align="center" bgcolor="#f05f26" style="border-radius: 8px;">
                          <!--[if mso]>
                          <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="https://easproject.com/signup" style="height:58px;v-text-anchor:middle;width:250px;" arcsize="14%" stroke="f" fillcolor="#f05f26">
                          <w:anchorlock/>
                          <center style="color:#ffffff;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;font-size:18px;font-weight:bold;">Start for Free</center>
                          </v:roundrect>
                          <![endif]-->
                          <!--[if !mso]><!-->
                          <a href="https://easproject.com/signup" style="display: inline-block; padding: 18px 36px; font-family: 'Helvetica Neue', Helvetica, Arial, Verdana, sans-serif; font-size: 18px; font-weight: bold; text-decoration: none; text-align: center; border-radius: 8px; background-color: #f05f26; color: #ffffff;">Start for Free</a>
                          <!--<![endif]-->
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>`;

// Section: Footer
const SECTION_FOOTER = `          <!-- ============================================
               FOOTER
          ============================================ -->
          <tr>
            <td style="background-color: #016193; padding: 24px;">
              <!-- Social Icons -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                <tr>
                  <td align="center" style="padding-bottom: 20px;">
                    <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                      <tr>
                        <td style="padding: 0 12px;">
                          <a href="https://www.linkedin.com/company/easproject/" target="_blank">
                            <img src="https://cdn-images.mailchimp.com/icons/social-block-v3/block-icons-v3/linkedin-filled-light-40.png" alt="LinkedIn" width="40" height="40" style="display: block; border: 0; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic;" />
                          </a>
                        </td>
                        <td style="padding: 0 12px;">
                          <a href="https://www.facebook.com/easproject" target="_blank">
                            <img src="https://cdn-images.mailchimp.com/icons/social-block-v3/block-icons-v3/facebook-filled-light-40.png" alt="Facebook" width="40" height="40" style="display: block; border: 0; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic;" />
                          </a>
                        </td>
                        <td style="padding: 0 12px;">
                          <a href="https://www.instagram.com/easproject" target="_blank">
                            <img src="https://cdn-images.mailchimp.com/icons/social-block-v3/block-icons-v3/instagram-filled-light-40.png" alt="Instagram" width="40" height="40" style="display: block; border: 0; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic;" />
                          </a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>

              <!-- Footer Content -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                <tr>
                  <td align="center" width="30%" style="vertical-align: middle; padding: 12px;">
                    <a href="https://easproject.com" target="_blank">
                      <img src="https://dashboard.easproject.com/img/EAS-logo-invert.png" alt="EAS Project" width="90" style="display: block; max-width: 100%; height: auto; border: 0; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic;" />
                    </a>
                  </td>
                  <td align="left" width="60%" style="vertical-align: middle; padding: 12px 16px;">
                    <p style="margin: 0 0 8px 0; color: #ffffff; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 12px; line-height: 1.6;">
                      EAS Project Ou, Mustamäe Tee 50, Tallinn, Harjumaa 10621, Estonia, +35840 500 3575
                    </p>
                    <p style="margin: 0; color: #8fb8cc; font-family: Arimo, Arial, 'Helvetica Neue', Helvetica, sans-serif; font-size: 12px; line-height: 1.6;">
                      Want to change how you receive these emails?<br/>
                      You can <a href="*|UPDATE_PROFILE|*" style="color: #8fb8cc; text-decoration: underline;">update your preferences</a> or <a href="*|UNSUB|*" style="color: #8fb8cc; text-decoration: underline;">unsubscribe</a>
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>`;

// Sections array for selection
export const EMAIL_TEMPLATE_SECTIONS: EmailTemplateSection[] = [
	{
		id: 'headings',
		name: 'Headings',
		html: SECTION_HEADINGS,
	},
	{
		id: 'paragraphs',
		name: 'Paragraphs',
		html: SECTION_PARAGRAPHS,
	},
	{
		id: 'unordered-lists',
		name: 'Unordered Lists',
		html: SECTION_UNORDERED_LISTS,
	},
	{
		id: 'ordered-lists',
		name: 'Ordered Lists',
		html: SECTION_ORDERED_LISTS,
	},
	{
		id: 'buttons',
		name: 'Buttons',
		html: SECTION_BUTTONS,
	},
	{
		id: 'data-table',
		name: 'Data Table',
		html: SECTION_DATA_TABLE,
	},
	{
		id: 'cta',
		name: 'Call to Action',
		html: SECTION_CTA,
	},
	{
		id: 'footer',
		name: 'Footer',
		html: SECTION_FOOTER,
	},
];

// Full template HTML
export const EMAIL_TEMPLATE_HTML = `
${TEMPLATE_HEAD}
          
${SECTION_HEADINGS}

${SECTION_PARAGRAPHS}

${SECTION_UNORDERED_LISTS}

${SECTION_ORDERED_LISTS}

${SECTION_BUTTONS}

${SECTION_DATA_TABLE}

${SECTION_CTA}

${SECTION_FOOTER}

${TEMPLATE_FOOTER}
`;

// Helper to wrap a section with the template shell for preview
export const wrapSectionWithTemplate = (sectionHtml: string): string => `
${TEMPLATE_HEAD}
          
${sectionHtml}

${TEMPLATE_FOOTER}
`;

// Empty template (without any sections)
export const EMAIL_TEMPLATE_EMPTY = `
${TEMPLATE_HEAD}

          <!-- Add your content sections here -->

${TEMPLATE_FOOTER}
`;
